import React from "react";
import tal from "../../img/tal.png";
import asteron from "../../img/asteron.jpg";
import suncorp from "../../img/suncorp.png";
import { title, verticalLine, image } from "../Shared/Styles";

export default function Title(props) {
  if (props.productDetails !== undefined) {
    return (
      <div className="Title">
        <div>
          {(props.productDetails[0].brandName === null ||
            props.productDetails[0].brandName === "TAL" ||
            ["STG", "BT", "WFS"].includes(
              props.productDetails[0].brandCode
            )) && <img style={image} src={tal} alt={"tal"} />}
          {props.productDetails[0].brandCode === "ASTN" && (
            <img style={image} src={asteron} alt={"asteron"} />
          )}
          {props.productDetails[0].brandCode === "SUN" && (
            <img
              style={{
                float: "right",
                marginRight: "80px",
                width: "25%",
                marginTop: "-85px",
              }}
              src={suncorp}
              alt={"suncorp"}
            />
          )}
        </div>

        <div style={verticalLine}>
          <h1 style={title}>Certificate of Currency</h1>
          {(props.productDetails[0].brandName === null ||
            props.productDetails[0].brandName === "TAL") && (
            <p style={title}>
              TAL Life Limited ABN 70 050 109 450 AFSL Number 237848
            </p>
          )}
        </div>
      </div>
    );
  }
}
